module.exports = " <div class=von-scalable-wrapper :style=\"{width: width, height: height}\"> <div class=von-scalable> <slot></slot> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/scalable/index.vue
// module id = 242
// module chunks = 0